import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const TripadvisorIcon = ({ color, width, height, display }) => (
  <IconWrapper width={width} height={height} display={display}>
    <svg width={width} height={height} viewBox="0 0 40 40">
      <g transform="translate(2 2)" fill="none" fillRule="evenodd">
        <circle
          stroke={theme.colors.sagelight}
          strokeLinecap="square"
          cx="18"
          cy="18"
          r="18"
        />
        <path
          d="M20.643 12.188c.53.08 1.05.222 1.563.39a10.39 10.39 0 0 1 2.536 1.232c.055.037.129.06.194.06.934.004 1.867.003 2.8.003.075 0 .15.009.225.013 0 .02.003.028 0 .033l-.132.213c-.316.518-.587 1.06-.747 1.658-.017.064-.02.118.02.181.831 1.273 1.097 2.67.75 4.175-.305 1.32-1.016 2.35-2.095 3.08a4.481 4.481 0 0 1-2.533.774 4.164 4.164 0 0 1-1.137-.156 4.715 4.715 0 0 1-2.333-1.467c-.085-.097-.165-.197-.255-.306l-1.018 1.617-1-1.594c-.023.013-.03.014-.034.019a.161.161 0 0 0-.02.022c-.778.979-1.756 1.58-2.948 1.78a4.331 4.331 0 0 1-1.964-.118A4.652 4.652 0 0 1 10.2 22.26a5.136 5.136 0 0 1-1.137-2.577c-.163-.912.036-1.792.086-2.006.144-.62.395-1.19.74-1.714a.21.21 0 0 0 .022-.147c-.141-.55-.384-1.05-.668-1.53-.072-.121-.158-.234-.238-.351v-.04c.016.001.032.005.048.005.955 0 1.91 0 2.865-.002a.232.232 0 0 0 .124-.042 10.038 10.038 0 0 1 2.138-1.106 11.053 11.053 0 0 1 1.659-.48 12.516 12.516 0 0 1 1.65-.23c1.353-.111 2.435.041 3.154.149zm-1.198 6.725c0 2.236 1.703 4.063 3.793 4.054 2.098-.008 3.793-1.783 3.791-4.044-.001-2.33-1.775-4.081-3.872-4.036-2.071.046-3.693 1.825-3.712 4.026zm-5.688-4.041c-2.04-.02-3.82 1.796-3.784 4.109.033 2.156 1.7 3.984 3.826 3.964 2.079-.018 3.75-1.828 3.754-4.019.003-2.251-1.688-4.054-3.796-4.054zm.188-1.055c1.153.075 2.165.503 3.02 1.332.855.828 1.355 1.86 1.537 3.075.186-1.2.674-2.223 1.511-3.042.84-.82 1.839-1.251 2.972-1.342-1.345-.638-2.764-.908-4.224-.938-1.66-.035-3.274.226-4.816.915zm9.285 2.545c1.299-.002 2.35 1.112 2.35 2.495 0 1.388-1.034 2.46-2.253 2.51-1.362.056-2.452-1.101-2.451-2.504.001-1.419 1.098-2.525 2.354-2.501zm1.532 2.501c-.001-.902-.685-1.635-1.526-1.635-.85 0-1.542.73-1.545 1.628-.003.896.692 1.64 1.534 1.643.844.004 1.537-.736 1.537-1.636zm-11.055-2.501c1.297-.002 2.35 1.115 2.347 2.498-.004 1.399-1.038 2.448-2.236 2.506-1.368.067-2.47-1.095-2.468-2.506.002-1.429 1.107-2.522 2.357-2.498zm1.53 2.495c-.003-.907-.692-1.63-1.551-1.629-.83.002-1.524.748-1.522 1.635.002.897.696 1.635 1.54 1.637.84.002 1.534-.743 1.532-1.643zm7.994-.824c.43 0 .783.376.78.831-.005.457-.352.828-.775.828-.435 0-.786-.367-.785-.822.001-.472.341-.837.78-.837zm-9.528-.008c.436 0 .787.372.79.836 0 .46-.353.838-.788.84-.445 0-.788-.366-.788-.843 0-.469.342-.832.786-.833z"
          fill={color}
        />
      </g>
    </svg>
  </IconWrapper>
)

TripadvisorIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
}

TripadvisorIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: '40px',
  height: '40px',
  display: 'inline-block',
}

export default TripadvisorIcon
